import React from 'react';
import { useLanguage } from './LanguageContext';
export function LanguageToggle() {
  const {
    language,
    setLanguage
  } = useLanguage();
  const toggleLanguage = () => {
    setLanguage(language === 'es' ? 'pt' : 'es');
  };
  return <button onClick={toggleLanguage} className="fixed top-6 right-6 z-50 flex items-center gap-2 bg-white/80 backdrop-blur-md border border-[#D4AF37]/40 px-4 py-2 rounded-full shadow-[0_4px_12px_rgba(0,0,0,0.05)] hover:shadow-[0_4px_16px_rgba(212,175,55,0.2)] transition-all duration-300 hover:scale-105" data-id="element-179">
      <span className="text-lg" data-id="element-180">🌐</span>
      <span className="font-serif font-medium text-[#2C1810] tracking-wider" data-id="element-181">
        {language === 'es' ? 'ES' : 'PT'}
      </span>
    </button>;
}